"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingCategory = exports.RateElementClassification = void 0;
var RateComponent_1 = __importDefault(require("./RateComponent"));
var RateCalculator_1 = __importDefault(require("./RateCalculator"));
var BillingDeterminantFactory_1 = __importDefault(require("./BillingDeterminantFactory"));
var sum_1 = __importDefault(require("lodash/sum"));
var ValidatorFactory_1 = __importDefault(require("./ValidatorFactory"));
var PriceProfile_1 = __importDefault(require("./PriceProfile"));
var RateElementClassification;
(function (RateElementClassification) {
    RateElementClassification["ENERGY"] = "energy";
    RateElementClassification["DEMAND"] = "demand";
    RateElementClassification["FIXED"] = "fixed";
    RateElementClassification["SURCHARGE"] = "surcharge";
})(RateElementClassification = exports.RateElementClassification || (exports.RateElementClassification = {}));
;
// Since the billing category is passed into a RateCalculator as part of the
// arguments, this enum exists for documentation rather than actual type safety.
// Once this compiles to JS, nothing will prevent an application from passing in
// an abitrary string for the billingCategory.
var BillingCategory;
(function (BillingCategory) {
    BillingCategory["TAX"] = "tax";
    BillingCategory["SUPPLY"] = "supply";
    BillingCategory["DELIVERY"] = "delivery";
})(BillingCategory = exports.BillingCategory || (exports.BillingCategory = {}));
var RateComponentsFactory = /** @class */ (function () {
    function RateComponentsFactory() {
    }
    RateComponentsFactory.make = function (_a, loadProfile, otherRateElements) {
        var rateElementType = _a.rateElementType, rateComponents = _a.rateComponents, name = _a.name, priceProfileData = _a.priceProfile;
        switch (rateElementType) {
            case 'SurchargeAsPercent':
                return rateComponents.map(function (_a) {
                    var rateComponentName = _a.name, charge = _a.charge, filterArgs = __rest(_a, ["name", "charge"]);
                    return otherRateElements
                        .filter(function (element) { return (new RateElement(element, loadProfile, []).matches(filterArgs)); })
                        .map(function (element) { return ({
                        charge: charge,
                        name: rateComponentName + " surcharge - " + element.name,
                        rateElementType: 'SurchargeAsPercent',
                        rateElement: new RateElement(element, loadProfile, []),
                    }); });
                }).flat();
            case 'HourlyEnergy':
                var priceProfile = new PriceProfile_1.default(priceProfileData, { year: loadProfile.year });
                return priceProfile.expanded().map(function (_a) {
                    var price = _a.price, hourOfYear = _a.hourOfYear;
                    return ({
                        name: name + " - Hour " + hourOfYear,
                        charge: price,
                        hourOfYear: hourOfYear,
                        rateElementType: 'HourlyEnergy',
                    });
                });
            default:
                return rateComponents;
        }
    };
    return RateComponentsFactory;
}());
var RateElement = /** @class */ (function () {
    function RateElement(rateElementArgs, loadProfile, otherRateElements) {
        var _this = this;
        if (otherRateElements === void 0) { otherRateElements = []; }
        this.errors = [];
        var id = rateElementArgs.id, rateElementType = rateElementArgs.rateElementType, name = rateElementArgs.name, billingCategory = rateElementArgs.billingCategory;
        this.id = id;
        this.name = name;
        this.type = rateElementType;
        this.billingCategory = billingCategory;
        var rateComponents = RateComponentsFactory.make(rateElementArgs, loadProfile, otherRateElements);
        this._rateComponents = rateComponents.map(function (_a) {
            var charge = _a.charge, name = _a.name, rest = __rest(_a, ["charge", "name"]);
            var billingDeterminants = BillingDeterminantFactory_1.default.make(rateElementType, __assign({}, rest), loadProfile);
            // set the classification based on the billing determinant
            _this.classification = billingDeterminants.rateElementClassification;
            return new RateComponent_1.default({ charge: charge, name: name, billingDeterminants: billingDeterminants });
        });
        if (RateCalculator_1.default.shouldValidate) {
            var validator = ValidatorFactory_1.default.make(rateElementType, rateComponents, loadProfile).validate();
            RateCalculator_1.default.shouldLogValidationErrors && validator.reportErrors();
            this.errors = validator.allErrors();
        }
    }
    RateElement.prototype.rateComponents = function () {
        return this._rateComponents;
    };
    RateElement.prototype.annualCost = function () {
        return sum_1.default(this.rateComponents().map(function (component) { return component.annualCost(); }));
    };
    RateElement.prototype.costs = function () {
        var costs = Array(12).fill(0);
        this.rateComponents().forEach(function (component) {
            component.costs().forEach(function (cost, monthIdx) {
                costs[monthIdx] += cost;
            });
        });
        return costs;
    };
    RateElement.prototype.matches = function (_a) {
        var billingCategories = _a.billingCategories, classifications = _a.classifications, ids = _a.ids;
        return (billingCategories ? billingCategories.includes(this.billingCategory) : true) &&
            (classifications ? classifications.includes(this.classification) : true) &&
            (ids ? ids.includes(this.id) : true);
    };
    return RateElement;
}());
exports.default = RateElement;
